import { Module } from 'vuex'
import { IState, IMenuState } from '@/types'

export const menuModule: Module<IMenuState, IState> = {
	namespaced: true,

	state: (): IMenuState => ({
		isOpen: false
	}),

	mutations: {
		setIsOpen(state: IMenuState, isOpen: boolean) {
			state.isOpen = isOpen
		}
	},

	actions: {
		setMenuOpen({ commit }, isOpen: boolean) {
			commit('setIsOpen', isOpen)
		}
	},

	getters: {
		isMenuOpen: (state: IMenuState) => state.isOpen
	}
}
